<template>
  <v-card
      v-if="!isEmpty(newApplication.environmentalStudyTypeRequired)"
      flat
      column>
    <v-subheader>
      Estudo Exigido
    </v-subheader>

    <v-card
        flat
        class="ml-3 px-4 py-2"
        color="grey lighten-5">
      <v-layout column>
        <v-flex class="mt-3 mb-3">
          <v-layout row justify-space-between align-center class="grey--text">
            <strong class="headline">{{ newApplication.environmentalStudyTypeRequired.name }}</strong>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>

  </v-card>

</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';

export default {
  name: 'ResumeEnvironmentalStudyTypeRequired',
  data() {
    return {
      isEmpty
    };
  },
  computed: {
    ...mapGetters('newApplication', ['newApplication']),
  },
};
</script>
